export default __webpack_public_path__ + "static/media/6.20c92e04.JPG";